// extracted by mini-css-extract-plugin
export default {"buttonContainer":"popout-player-dialog-module__buttonContainer___wttsS","messageContainer":"popout-player-dialog-module__messageContainer___kiomi"};